import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

// Renders the homepage "discount image" misc-photo slot at the same card size as a
// CategoryShowcase card: full width (stacked) on mobile, centered at one category
// column's width on desktop.
const DiscountImageSection = ({ photo }) => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    const link = photo?.link?.trim();
    if (!link) return;
    if (/^https?:\/\//i.test(link)) {
      window.location.href = link;
    } else {
      navigate(link.startsWith('/') ? link : `/${link}`);
    }
  }, [photo, navigate]);

  if (!photo || !photo.image) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8 sm:pb-14">
      <button
        onClick={handleClick}
        className="group relative w-full md:w-[calc((100%-1.25rem)/2)] md:mx-auto block rounded-2xl overflow-hidden bg-gray-100 shadow-sm hover:shadow-xl transition-shadow duration-300"
        style={{ aspectRatio: '1594/656' }}
      >
        <img
          src={photo.image}
          srcSet={photo.image_srcset || undefined}
          sizes="(min-width: 768px) 50vw, 100vw"
          alt={photo.name || 'Discount'}
          className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
          loading="lazy"
          decoding="async"
        />
      </button>
    </div>
  );
};

export default DiscountImageSection;
